import { createReducer, on } from '@ngrx/store';
import * as SecurityActions from '@core/ngrx/actions/security.actions';

export interface State {
  roles: string[];
  permissions: string[];
}

export const initialState: State = {
  roles: [],
  permissions: []
};

export const security = createReducer(
  initialState,

  on(SecurityActions.setRoles, (state, { roles }) => ({ ...state, roles })),
  on(SecurityActions.setPermissions, (state, { permissions }) => ({ ...state, permissions })),
  on(SecurityActions.setUserAccess, (state, { roles, permissions }) => ({ ...state, roles, permissions }))
);
